import React from 'react';
import LegalPage from './LegalPage';

const sections = [
  {
    heading: 'Information We Collect',
    body: 'When you contact us through this website, whether by filling out our contact form or booking an appointment, we collect the information you provide directly: your name, phone number, email address, the service you\'re requesting, and any details you share in your message.'
  },
  {
    heading: 'How We Use Your Information',
    body: 'We use this information only to respond to your inquiry, confirm appointment details, and provide the notary services you\'ve requested. We do not sell, rent, or share your information with third parties for marketing purposes.'
  },
  {
    heading: 'How We Store Your Information',
    body: 'Contact form submissions are stored securely using Supabase, a third-party data platform. Email notifications about new inquiries are sent through Resend, a transactional email provider. Both services are used solely to operate this contact form and are not used for any other purpose.'
  },
  {
    heading: 'Your Rights',
    body: 'You may request that we delete any information you\'ve submitted to us at any time by contacting us at [business email]. We will honor such requests within a reasonable timeframe.'
  },
  {
    heading: 'Cookies and Analytics',
    body: 'This website may use basic analytics tools to understand how visitors use the site. These tools do not collect personally identifiable information beyond what you voluntarily submit through our contact form.'
  },
  {
    heading: 'Changes to This Policy',
    body: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.'
  },
  {
    heading: 'Contact Us',
    body: 'If you have questions about this Privacy Policy or how your information is handled, contact us at [business email] or (240) 571-3117.'
  }
];

const PrivacyPolicyPage = () => (
  <LegalPage
    title="Privacy Policy | Pronto Notary"
    description="Read the Pronto Notary Privacy Policy to learn how contact and appointment information is collected, used, and protected."
    sections={sections}
  />
);

export default PrivacyPolicyPage;